module.exports = __webpack_public_path__ + "static/media/bleu3_optim.95886c8b.jpg";